import { getEnv } from '~/utils/env';

export function getAcquisitionURL(businessUnit: string): string {
  return getEnv(`ACQUISITION_SERVICE_URL_${businessUnit.toUpperCase()}`);
}

export function getAcquisitionToken(businessUnit: string): string {
  return getEnv(`ACQUISITION_API_TOKEN_${businessUnit.toUpperCase()}`);
}
